import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#112240] group-[.toaster]:text-[#F8FAFC] group-[.toaster]:border-[rgba(255,255,255,0.1)] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#94A3B8]",
          actionButton:
            "group-[.toast]:bg-[#14B8A6] group-[.toast]:text-[#050B14]",
          cancelButton:
            "group-[.toast]:bg-[#1E293B] group-[.toast]:text-[#94A3B8]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
